import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import styled from "styled-components"
import LibraryPickerDropdown from "../../library/picker/LibraryPickerDropdown"
import withCreatePathItem from "../graphql/withCreatePathItem"
import { useEditPathContext } from "./EditPath"

const StyledLibraryPickerDropdownWrapper = styled.div`
  ${({ hasParent }) =>
    hasParent
      ? `
  position: relative;

   .PickerDropdown:not(.PickerDropdown__fullscreen) {
    top: calc(50% + 10px);
  }
  `
      : ""}
`

const EditPathAddResource = ({
  createPathItem,
  handlePicking,
  index,
  pathId,
  parentId,
  inverted
}) => {
  const [error, setError] = useState(null)
  const [picking, setPicking] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const { pathItems, clearEditingState, handleChange } = useEditPathContext()

  const { tc } = useTranslate()

  let resourceIdsOnPath = []

  function checkPathItem(pathItem) {
    // We expect a linked resource to exist on resource steps but there could
    // possible be some edge case where the linked resource isn't included
    // on the resource step due to a school mismatched where the linked resource
    // exists on a different school (due to some unknown bug as of yet).
    if (pathItem.type === "resource" && pathItem.linked_resource) {
      resourceIdsOnPath.push(pathItem.linked_resource.id)
    }
    if (pathItem.items) {
      pathItem.items.forEach(checkPathItem)
    }
  }
  pathItems.forEach(checkPathItem)

  const pickResource = async (resource) => {
    setPicking(false)
    setSubmitting(true)
    try {
      await createPathItem({
        type: "resource",
        name: resource.name,
        order: index,
        pathId: pathId,
        parent: parentId,
        content_type: "resource",
        content_resource: resource.id
      }).then(() => {
        clearEditingState()
        // alert parent (legacy/client) that changes have occurred.
        handleChange()
      })
    } catch (error) {
      setError(error)
    } finally {
      setSubmitting(false)
    }
  }

  useEffect(() => {
    handlePicking && handlePicking(picking)
  }, [picking])

  return (
    <>
      <SubmitButton
        onClick={() => setPicking(true)}
        submitting={submitting}
        inverted={inverted}
        styleType="secondary"
        size="large"
        brand={false}
      >
        {tc("Add a Path")}
      </SubmitButton>
      {picking && (
        // When the Add a Path button (for Collections) appears as the standalone button in a Path Group, it needs special styling
        <StyledLibraryPickerDropdownWrapper hasParent={parentId !== undefined}>
          <LibraryPickerDropdown
            onPick={pickResource}
            onOutsideClick={() => setPicking(false)}
            resourceIdsFilter={
              resourceIdsOnPath.length
                ? {
                    nin: resourceIdsOnPath // dont show courses already included
                  }
                : null
            }
            resourceTypeFilter={{
              neq: "collection" // dont show collections
            }}
          />
        </StyledLibraryPickerDropdownWrapper>
      )}
    </>
  )
}

EditPathAddResource.displayName = "EditPathAddResource"

EditPathAddResource.propTypes = {
  index: PropTypes.number.isRequired,
  pathId: PropTypes.number.isRequired,
  parentId: PropTypes.number,
  inverted: PropTypes.bool
}

export default withCreatePathItem(EditPathAddResource)
